import { useTheme } from '../lib/theme-provider';
import { ThemedCard } from './ThemedCard';
import { Eye, Users } from 'lucide-react';

interface Spectator {
  id: string;
  nickname: string;
  joinedAt: string;
}

interface SpectatorListProps {
  spectators: Spectator[];
  isSpectator: boolean;
}

export default function SpectatorList({
  spectators,
  isSpectator,
}: SpectatorListProps) {
  const { theme } = useTheme();

  if (spectators.length === 0 && !isSpectator) {
    return null;
  }

  return (
    <ThemedCard className="p-4">
      {/* 标题 */}
      <div className="flex items-center gap-2 mb-3">
        <Eye size={18} style={{ color: theme.colors['text-secondary'] }} />
        <span
          className="font-bold"
          style={{ color: theme.colors['text-primary'] }}
        >
          观战者
        </span>
        <span
          className="text-sm"
          style={{ color: theme.colors['text-secondary'] }}
        >
          ({spectators.length})
        </span>
      </div>

      {/* 观战者列表 */}
      {spectators.length === 0 ? (
        <div
          className="text-center py-4 text-sm"
          style={{ color: theme.colors['text-muted'] }}
        >
          暂无观战者
        </div>
      ) : (
        <div className="space-y-2">
          {spectators.map((spectator) => (
            <div
              key={spectator.id}
              className="flex items-center gap-3 p-2 rounded-lg"
              style={{ backgroundColor: theme.colors['bg-primary'] }}
            >
              {/* 头像 */}
              <div
                className="w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold"
                style={{
                  backgroundColor: theme.colors['text-muted'],
                  color: theme.colors['bg-primary'],
                }}
              >
                {spectator.nickname[0]}
              </div>

              {/* 昵称 */}
              <span
                className="flex-1 text-sm font-medium"
                style={{ color: theme.colors['text-secondary'] }}
              >
                {spectator.nickname}
              </span>

              {/* 观战中标识 */}
              <span
                className="text-xs px-2 py-0.5 rounded"
                style={{
                  backgroundColor: `${theme.colors['text-muted']}30`,
                  color: theme.colors['text-muted'],
                }}
              >
                观战中
              </span>
            </div>
          ))}
        </div>
      )}

      {/* 当前用户是观战者的提示 */}
      {isSpectator && (
        <div
          className="mt-3 p-3 rounded-lg text-center text-sm"
          style={{
            backgroundColor: `${theme.colors['accent-gold']}10`,
            border: `1px solid ${theme.colors['accent-gold']}30`,
            color: theme.colors['accent-gold'],
          }}
        >
          您当前正在观战，无法参与游戏
        </div>
      )}
    </ThemedCard>
  );
}
